import { ICellRender, ICols } from "../shared/table/types";
import cells from "../shared/table/cells";
import { Cells } from "../shared/constant";

const tableUtils = {
  buildColumns: function buildColumns(
    data: any[],
    columns: ICols[],
    actions?: any,
    controlledColumns?: any[] | null,
    onHeaderClick?: Function,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    selectedRowKeys?: React.Key[],
  ) {
    // console.log("Table Utils: ", data, columns, actions, selectedRowKeys);
    const cols: any[] = [];
    const keys = data.length > 0 ? Object.keys(data[0]) : [];

    columns.forEach(({ key, header, cell, width }: ICols) => {
      /* Notes: keyParts is using to parse from object.  
         ex. key="invoice.invoice_no" or key="invoice.invoice_date.date" */

      const keyParts = key.includes(".") ? key.split(".") : [key];

      if (keys.includes(keyParts[0]))
        cols.push({
          title: header,
          dataIndex: keyParts[0],
          key: keyParts[0],
          width,
          render: (value: any, record: any, index: number) => {
            let cValue = value;
            if (keyParts.length > 1) {
              const cKparts = [...keyParts];
              cKparts.shift();
              cValue = cKparts.reduce((acc, curr) => acc && acc[curr], value);
            }
            const props: ICellRender = { value: cValue, record, index, cell };
            return this.cellView(props);
          },
          onHeaderCell: (column: any) => {
            return {
              onClick: () => onHeaderClick && onHeaderClick(column),
            };
          },
        });
    });

    if (actions) cols.push(actions);

    if (controlledColumns && controlledColumns.length) {
      controlledColumns.map((col: any) => {
        const { position, ...controlledCol } = col;
        return cols.splice(position, 0, controlledCol);
      });
    }

    return cols;
  },
  cellView: function cellView(props: ICellRender) {
    switch (props.cell) {
      case Cells.FILE_ICON_CELL:
        return cells.FileIconCell(props);
      case Cells.LINK_CELL:
        return cells.LinkCell(props);
      case Cells.FILE_SIZE_CELL:
        return cells.FileSizeCell(props);
      case Cells.DATE_CELL:
        return cells.DateCell(props);
      case Cells.UPLOAD_STATUS_CELL:
        return cells.UploadStatusCell(props);
      case Cells.MUSIC_ICON_CELL:
        return cells.MusicIconCell(props);
      case Cells.ROLE_CELL:
        return cells.RoleCell(props);
      case Cells.STATUS_CELL:
        return cells.StatusCell(props);
      case Cells.SIGNUP_STATUS_CELL:
        return cells.SignupStatusCell(props);
      case Cells.USER_AVATAR_CELL:
        return cells.UserAvatarCell(props);
      case Cells.LABEL_CELL:
        return cells.LabelCell(props);
      case Cells.PERCENTAGE_TAG_CELL:
        return cells.PercentageTagCell(props);
      case Cells.MULTIPLE_PERCENTAGE_TAG_CELL:
        return cells.MultiplePercentageTagCell(props);
      case Cells.CLIENT_TYPES_CELL:
        return cells.ClientTypesCell(props);
      case Cells.CLIENT_LOGO_CELL:
        return cells.ClientLogoCell(props);
      case Cells.CLIENT_NAME_CELL:
        return cells.ClientNameCell(props);
      case Cells.BDT_CELL:
        return cells.BDTCell(props);
      case Cells.EUR_CELL:
        return cells.EURCell(props);
      case Cells.USD_CELL:
        return cells.USDCell(props);
      case Cells.TOTAL_DUE_CELL:
        return cells.TotalDueCell(props);
      case Cells.PAYMENT_STATUS_CELL:
        return cells.PaymentStatusCell(props);
      case Cells.INVOICE_STATUS_CELL:
        return cells.InvoiceStatusCell(props);
      case Cells.INVOICE_NO_CELL:
        return cells.InvoiceNoCell(props);
      case Cells.EXCHANGE_RATE_CELL:
        return cells.ExchangeRateCell(props);
      case Cells.INVOICE_AMOUNT_CELL:
        return cells.InvoiceAmountCell(props);
      case Cells.PRIMARY_COLORED_CELL:
        return cells.primaryColoredCell(props);

      default:
        return cells.TextCell(props);
    }
  },
};

export default tableUtils;
